import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BcmApiService } from '@bcmApiServices/bcm-api.service';
import { parseHttpResponseItem, parseHttpResponseList, parseHttpResponsePage } from '@shared/functions/parse-http-response';
import { Page, PageRequest } from '@shared/models/pagination';
import { BcmFinancialRecord, BcmFinancialRecordDto } from '@shared/models/bcm-financial-record';

export const DEFAULT_RECENT_FINANCIAL_RECORDS_LIMIT = 20;

@Injectable({
    providedIn: 'root'
})
export class BcmFinancialRecordsApiService extends BcmApiService {

    private RESOURCE_ENDPOINT = 'financial-records';

    getAll(pageRequest: PageRequest<BcmFinancialRecord>): Observable<Page<BcmFinancialRecord>> {
        return super.get<Page<BcmFinancialRecordDto>>(this.RESOURCE_ENDPOINT, pageRequest.getHttpParams())
            .pipe(parseHttpResponsePage<BcmFinancialRecordDto, BcmFinancialRecord>(BcmFinancialRecord));
    }

    getRecentToday(limit = DEFAULT_RECENT_FINANCIAL_RECORDS_LIMIT): Observable<BcmFinancialRecord[]> {
        const params = new HttpParams().set('limit', String(limit));

        return super.get<BcmFinancialRecordDto[]>(`${this.RESOURCE_ENDPOINT}/recent`, params)
            .pipe(parseHttpResponseList<BcmFinancialRecordDto, BcmFinancialRecord>(BcmFinancialRecord));
    }

    getOne(recordNumber: string | number, params: HttpParams = new HttpParams()): Observable<BcmFinancialRecord> {
        return super.get<BcmFinancialRecordDto>(`${this.RESOURCE_ENDPOINT}/${encodeURIComponent(String(recordNumber))}`, params)
            .pipe(parseHttpResponseItem<BcmFinancialRecordDto, BcmFinancialRecord>(BcmFinancialRecord));
    }


}
